import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLabel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 7.95c0-1.12 0-1.68.221-2.108.195-.376.506-.682.888-.874.435-.218 1.004-.218 2.142-.218h7.837c.59 0 .886 0 1.157.076.24.067.466.177.666.324.226.167.405.398.763.86l2.337 3.02c.269.348.403.521.455.713a.984.984 0 0 1 0 .514c-.052.192-.186.365-.455.713l-2.337 3.02c-.358.462-.537.693-.763.86-.2.147-.425.257-.666.324-.271.076-.566.076-1.157.076H5c-1.138 0-1.707 0-2.142-.218a2.016 2.016 0 0 1-.888-.874c-.221-.428-.221-.988-.221-2.108v-4.1Z"
	})]
});
const ForwardRef = forwardRef(SvgLabel);
export { ForwardRef as ReactComponent };
